import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cosy-grid-rowdetail-preload',
  templateUrl: './cosy-grid-rowdetail-preload.component.html',
  styleUrls: ['./cosy-grid-rowdetail-preload.component.css']
})
export class CosyGridRowdetailPreloadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
